import Telegram from '../images/telegram.svg';
import Whatsapp from '../images/whatsapp.svg';

export const CONTACTS = [
    {
        alt: 'linkedin',
        img: '/linkedin.svg',
        link: "https://www.linkedin.com/in/smart-ui-company/"
    },
    {
        alt: 'upwork',
        img: '/upwork.svg',
        link: "https://www.upwork.com/ag/smartui/"
    },
    {
        alt: 'clutch',
        img: '/clutch.svg',
        link: "https://clutch.co/profile/smart-ui?utm_source=widget&utm_medium=1&utm_campaign=widget&utm_content=logo#summary"
    },
]

export const MESSENGERS = [
    {
        img: Whatsapp,
        link: 'https://wa.me/+34634839752',
        alt: 'Whatsapp'
    },
    {
        img: Telegram,
        link: 'https://t.me/alexgashkov1',
        alt: 'Telegram'
    }
]
